import {
    PerspectiveCamera,
    WebGLRenderer,
    sRGBEncoding
} from 'three'
import {FirstPersonController} from "./FirstPersonController";

function createCamera() {
    // add camera
    const fov = 70 // Field of view
    const aspect = window.innerWidth / window.innerHeight
    const near = 0.1 // the near clipping cutoutPlane
    const far = 50 // the far clipping cutoutPlane
    const camera = new PerspectiveCamera(fov, aspect, near, far)
    camera.position.set(0, 10, 0)
    camera.updateProjectionMatrix()
    return camera
}

function createFirstPersonCamera() {
    // add camera
    const fov = 70 // Field of view
    const aspect = window.innerWidth / window.innerHeight
    const near = 0.1 // the near clipping cutoutPlane
    const far = 60 // the far clipping cutoutPlane
    const camera = new PerspectiveCamera(fov, aspect, near, far)
    camera.position.set(0, 1.75, 0)
    camera.updateProjectionMatrix()
    return camera
}

function createRenderer() {
    const renderer = new WebGLRenderer({antialias: true})
    renderer.setSize(window.innerWidth, window.innerHeight)
    renderer.setPixelRatio(window.devicePixelRatio)
    renderer.gammaFactor = 2.2
    renderer.outputEncoding = sRGBEncoding
    renderer.physicallyCorrectLights = true
    return renderer
}

function createFirstPersonControls(cam, cont) {
    // add controls
    const controls = new FirstPersonController( cam, cont);
    controls.lookVertical = true
    controls.constrainVertical = true
    controls.verticalMin = 1.1
    controls.verticalMax = 2.2
    controls.lookSpeed = 0.1
    return controls
}

export default {createCamera, createFirstPersonCamera, createFirstPersonControls, createRenderer}
